/* import __COLOCATED_TEMPLATE__ from './chef-hat.hbs.js'; */
import Component from '@glimmer/component';
export default class ChefHat extends Component {
  get fill() {
    return this.args.fill || 'var(--core-text-10-light-mode-color)';
  }
  get fillOpacity() {
    return this.args.fillOpacity || '1';
  }
  get width() {
    return this.args.width || '24';
  }
  get height() {
    return this.args.height || '24';
  }
}